import {
    createContext, Dispatch, Key, SetStateAction,
} from 'react';

export interface IDocumentUploadTemplateContextArgs {
    entityName: string;
    selectedTabKey: Key | null;
    setSelectedTabKey: Dispatch<SetStateAction<Key>> | null;
    isCreatingNewTemplate: boolean;
    templateCode?: string;
}

export const DocumentUploadTemplateContext = createContext<IDocumentUploadTemplateContextArgs>({
    entityName: '',
    selectedTabKey: null,
    setSelectedTabKey: null,
    isCreatingNewTemplate: false,
});
